module.exports = __webpack_public_path__ + "img/02-3.df45bb05.png";